module.exports = __webpack_public_path__ + "img/add.a3165feb.svg";